import './header.css';
import icon from './Logo ApexLoom Black.svg';

function Header(){
    return(
        <header>
            <img src={icon} alt="" />
            <nav>
                <ul>
                    <li><a href="/sobre">Sobre</a></li>
                    <li><a href="/services">Serviços</a></li>
                    <li><a href="/orcamento">Orçamento</a></li>
                    <li><a href="/contato">Contato</a></li>
                </ul>
            </nav>
        </header>
    );
}

export default Header;